import { useGetRelatedCompanies } from '@apps-common/apis/portal/company'
import { useGetUnitNetworkTypes } from '@apps-common/apis/portal/unit'
import { IUnitPortalSelectOption } from '@apps-common/types/form'

export interface IPortalUnitSelectItem {
  defaultValue?: string
  options: IUnitPortalSelectOption[]
  refetch: any
}

export interface IPortalUnitSelectItems {
  isLoading: boolean
  monitoringCentres: IPortalUnitSelectItem
  bureaus: IPortalUnitSelectItem
  technicians: IPortalUnitSelectItem
  networkTypes: IPortalUnitSelectItem
}

export const usePortalUnitSelectItems = (): IPortalUnitSelectItems => {
  const {
    data: monitoringCentres,
    isLoading: monitoringCentresLoading,
    isError: monitoringCentresError,
    refetch: monitoringCentresRefetch
  } = useGetRelatedCompanies({
    config: {},
    type: 'monitoring_centres'
  })

  const {
    data: bureaus,
    isLoading: bureausLoading,
    isError: bureausError,
    refetch: bureausRefetch
  } = useGetRelatedCompanies({
    config: {},
    type: 'bureaus'
  })

  const {
    data: technicians,
    isLoading: techniciansLoading,
    isError: techniciansError,
    refetch: techniciansRefetch
  } = useGetRelatedCompanies({
    config: {},
    type: 'technicians'
  })

  const {
    data: networkTypes,
    isLoading: networkTypesLoading,
    isError: networkTypesError,
    refetch: networkTypesRefetch
  } = useGetUnitNetworkTypes({
    config: {}
  })
  const isLoading =
    monitoringCentresLoading ||
    monitoringCentresError ||
    bureausLoading ||
    bureausError ||
    techniciansLoading ||
    techniciansError ||
    networkTypesLoading ||
    networkTypesError

  const defaultItem: IPortalUnitSelectItem = {
    defaultValue: '',
    options: [],
    refetch: () => {}
  }

  return isLoading
    ? {
        isLoading,
        monitoringCentres: defaultItem,
        bureaus: defaultItem,
        technicians: defaultItem,
        networkTypes: defaultItem
      }
    : {
        isLoading,
        monitoringCentres: {
          defaultValue: '',
          options: monitoringCentres?.map((c) => ({ label: c.companyName, value: c.companyId })) || [],
          refetch: monitoringCentresRefetch
        },
        bureaus: {
          defaultValue: '',
          options: bureaus?.map((c) => ({ label: c.companyName, value: c.companyId })) || [],
          refetch: bureausRefetch
        },
        technicians: {
          defaultValue: '',
          options: technicians?.map((c) => ({ label: c.companyName, value: c.companyId })) || [],
          refetch: techniciansRefetch
        },
        networkTypes: {
          defaultValue: '',
          options: networkTypes?.map((n) => ({ label: n.networkType, value: n.networkType })) || [],
          refetch: networkTypesRefetch
        }
      }
}
